import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const MessageLinkStyled = styled(Link)`
  color: ${(props) => props.theme.colors.text.link};
  text-decoration: underline;
`
